export default __webpack_public_path__ + "static/media/arrow-left.e89e18cc.svg";